export const ALERT_MOBILE_HEIGHT = '6.5rem';
export const ALERT_DESKTOP_HEIGHT = '2.8rem';

export const ALERT_EXCLUSION_URIS = String(process.env.GATSBY_ALERT_EXCLUSION_URIS).split(',');
